import { Controller } from "@hotwired/stimulus"

import { renderMarkdown } from "../../lib/render-markdown"

// KB Article Markdown Preview (read-only rendering for portal/show contexts)
// The admin editor uses Lexxy (WYSIWYG rich text) — this controller is only
// used when we need client-side markdown preview outside of the editor context.
//
// data-controller="support--kb-editor"

export default class extends Controller {
  static targets = ["input", "preview"]

  connect() {
    if (this.hasInputTarget && this.hasPreviewTarget) {
      this.render()
    }
  }

  render() {
    if (!this.hasInputTarget || !this.hasPreviewTarget) return

    const markdown = this.inputTarget.value || ""
    this.previewTarget.innerHTML = markdown.trim()
      ? renderMarkdown(markdown)
      : '<p class="text-muted-foreground italic">Preview will appear here...</p>'
  }
}
